import Logger from 'utils/logger';

import readFileAsDataURL from './components/documents/utils/readFileAsDataURL';

export const createFileUploadHandler = (
  setFieldValue: (field: string, value: any) => void,
  fieldPath: string,
  currentValue: string | undefined,
) => {
  return async (files: File[]) => {
    const [file] = files;
    const isRemovingFile = !file && currentValue;

    if (isRemovingFile) {
      setFieldValue(fieldPath, '');
      return;
    }

    if (file) {
      try {
        const base64String = await readFileAsDataURL(file);
        setFieldValue(fieldPath, base64String);
      } catch (error) {
        Logger.error('Error converting file to base64:', error);
      }
    }
  };
};
